<template>
    <v-card flat>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-text-field
                            :value="selectedItem.name"
                            label="Nome"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                        <v-text-field
                            :value="selectedItem.email"
                            label="Email"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6">
                        <v-checkbox
                            v-model="is_email_confirmed"
                            label="Email Confirmado"
                            readonly
                            hide-details="auto"
                        ></v-checkbox>
                    </v-col>

                    <v-col cols="6" sm="6" md="6">
                        <v-checkbox
                            v-model="selectedItem.is_active"
                            label="Conta Ativa"
                            readonly
                            hide-details="auto"
                        ></v-checkbox>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>


<script>
export default {
  name: 'User',
  props: {
    selectedItem: {
        type: Object,
        required: true,
    },
  },
  data: () => ({
    is_email_confirmed: null,
  }),
  mounted () {
    this.is_email_confirmed = this.selectedItem.confirmation_email && this.selectedItem.confirmation_email.confirmed_at != null ? true : false;
  },
}
</script>
